import request from '@/utils/request'

//展会介绍
export function getDetail() {
  return request({
    url: '/api/about',
    method: 'get'
  })
}


// 陶瓷与卫浴展香港新闻
export function getNewsList(params={}) {
  return request({
    url: '/api/news/wyz',
    method: 'get',
    params
  })
}
// 陶瓷装备
export function getNewsList2(params) {
  return request({
    url: '/api/news/clz',
    method: 'get',
    params
  })
}

//新闻详情
export function getNewsDetail(id) {
  return request({
    url: '/api/news/'+id,
    method: 'get'
  })
}


//媒体报道
export function getMediaList(params){
  return request({
    url: '/api/news/mtbd',
    method: 'get',
    params
  })
}

//观展服务
export function getServiceList(params){
  return request({
    url: '/api/news/gzfw',
    method: 'get',
    params
  })
}

//图片列表
export function getPicList(params){
  return request({
    url: '/api/nphone',
    method: 'get',
    params
  })
}